import MatchUpcoming from "./MatchUpcoming";
// import PubgForm from "../admin/Pubgform";
// import PubgTable from "../admin/PubgTable";
// import UserTable from '../admin/userTable';
import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MatchLive from '../pages/MatchLive';
// import manStyle from './Tournament.css';
import './Tournament.css';

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={0} mt={1}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        // backgroundColor: 'black',
        // color:'red'
    },
}));

export default function NavTabs() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>

            <Paper className={classes.root}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="UPCOMING" />
                    <Tab label="LIVE"/>
                    <Tab label="RESULTS"/>
                </Tabs>
            </Paper>
            <TabPanel value={value} index={0}>
                <MatchUpcoming/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <MatchLive/>
            </TabPanel>
        </div>
    );
}
